import React, { useEffect } from "react";
import { observer } from "mobx-react";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import walletStore from "./stores/wallet/wallet-store";
import WalletCard from "./components/wallet/wallet-card"
import "./billing-page.scss";
import WalletBillingHistory from "./components/wallet/wallet-billing-history";
import WalletPaymentMethodErrorTopBar from "./components/wallet/wallet-payment-method-error-top-bar";
import OverviewCard from "./components/overview-card/overview-card";
import dashboardSettingsStore from "../../stores/dashboard-settings-store";
import { PROFILE_CAPABILITIES } from "../../models/ProfileCapabilities";

const BillingPage: React.FC = observer(() => {
    const billingHistoryCapability = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.BILLING_HISTORY);
    const walletCapability = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.WALLET);
    const isWalletSupported = walletCapability.isSupported;
    
    useEffect(() => {
        if (isWalletSupported) {
            walletStore.load();
        }
    }, [isWalletSupported]);

    /** Component level guard: return null if billing history is not supported */
    if (!billingHistoryCapability.isBillingHistorySupported) {
        return null;
    }

    return (
        <BasePageLayout 
            title={'Account - Billing'}
        >
            <div className="billing-page-new">
                {isWalletSupported && walletStore.failedDepositTransactionsStore.isLoaded && walletStore.failedDepositTransactionsStore.transactions.length > 0 && (
                    <WalletPaymentMethodErrorTopBar walletStore={walletStore} />
                )}
                <div className="billing-page-layout">
                    <div className="billing-page-content">
                        <OverviewCard walletStore={walletStore} />
                        <WalletBillingHistory />
                    </div>
                    {isWalletSupported && (
                        <div className="billing-page-wallet-container">
                            <WalletCard walletStore={walletStore} />
                        </div>
                    )}
                </div>
            </div>
        </BasePageLayout>
    )
});

export default BillingPage;
